import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, map } from 'rxjs/operators';
import { ScheduleService } from '../../service/schedule.service';
import * as calendarsActions from './calendars.actions';

@Injectable()
export class CalendarsEffects {

  constructor(private actions$: Actions, private scheduleService: ScheduleService) {

  }

  list$ = createEffect(() =>
    this.actions$.pipe(
      ofType(calendarsActions.calendarList),
      exhaustMap(() =>
        this.scheduleService.getCalendarActivities().pipe(
          map(response => {
            return calendarsActions.calendarListSuccess({calendars: response.calendar});
          })
        )
      )
    )
  );

  listRoles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(calendarsActions.rolesList),
      exhaustMap(() =>
        this.scheduleService.getRoles().pipe(
          map(response => {
            return calendarsActions.rolesListSuccess({roles: response});
          })
        )
      )
    )
  );
}
